import * as React from 'react';
import { PassengerFragment, SegmentFragment, TravellerFieldEnum, InfoMessageTypeEnum } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { Flight, Person } from '../Icons';
import { useTheme } from '../theme';
import { API_DATE_FORMAT, format, getTravellerName, getUserValue } from '../utils';
import Notification from '../Notification';
import { parse } from 'date-fns';
import ModalConfirm from '../ModalConfirm/components/ModalConfirm';

interface Props {
	traveller: PassengerFragment;
	segment: SegmentFragment;
	rejectMessage?: string;
	onClose?: () => void;
	onNewSearch?: () => void;
	open?: boolean;
}

const SubsidyRejectPopup: React.FC<Props> = ({ open, segment, traveller, rejectMessage, onClose, onNewSearch }) => {
	const { t } = useTranslation('PassengerSubsidy');
	const theme = useTheme('SubsidyRejectPopup').SubsidyRejectPopup;

	if (!traveller) {
		return null;
	}

	const fullName = getTravellerName(traveller),
		birthDate = getUserValue(traveller, TravellerFieldEnum.BirthDate);

	return (
		<ModalConfirm
			isOpen={open}
			onClose={onClose}
			size="medium"
			title={t('Attention')}
			confirmBtn={t('New search')}
			onConfirm={onNewSearch}
			cancelBtn={t('Edit passengers data')}
			onCancel={onClose}
		>
			{segment && (
				<div className={theme.flight}>
					<div className={theme.flight__direction}>
						{Flight}
						{segment.departure.airport.city.name} – {segment.arrival.airport.city.name}
					</div>

					<div>{format(parse(segment.departure.date, API_DATE_FORMAT, new Date()), 'd MMM, eeeeee')}</div>
				</div>
			)}
			<div className={theme.passenger}>
				{Person}
				{fullName}, {birthDate}
			</div>
			<Notification
				title={rejectMessage}
				status={InfoMessageTypeEnum.Warning}
				type="context"
				titleClassName={theme.notification__title}
				infoMessage={{
					title: rejectMessage,
					text: t('A subsidized fare requires all passengers on the booking to have benefits.'),
					type: InfoMessageTypeEnum.Warning,
					code: null
				}}
			/>
		</ModalConfirm>
	);
};

export default SubsidyRejectPopup;
